// 藏寶相關 API 工具
export async function uploadTreasure(
  photo,
  desc,
  treasurePlace,
  apiBaseUrl,
  userId,
  extraData = {}
) {
  try {
    const payload = {
      timestamp: treasurePlace?.timestamp || new Date().toISOString(),
      location: treasurePlace?.geometry?.location || {},
      description: desc,
      userId,
      ...extraData,
    };
    const formData = new FormData();
    formData.append("timestamp", payload.timestamp);
    formData.append("lat", payload.location.lat);
    formData.append("lng", payload.location.lng);
    formData.append("description", payload.description);
    formData.append("userId", userId);
    // 傳送額外欄位
    Object.entries(extraData).forEach(([key, value]) => {
      formData.append(key, value);
    });
    if (photo) formData.append("photo", photo);
    const res = await fetch(`${apiBaseUrl}/api/treasure/upload`, {
      method: "POST",
      body: formData,
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || "藏寶上傳失敗");
    return data;
  } catch (err) {
    console.error("[藏寶] 上傳失敗", err);
    throw err;
  }
}
